// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.c-share-dialog {\n  border: 4px solid var(--v-primary-base);\n  border-radius: 32px;\n}\n.c-share-dialog:not(.v-dialog--fullscreen) {\n  max-height: 50%;\n  min-height: 200px;\n}\n.c-share-toolbar {\n  flex-grow: 0;\n}\n.c-share-icon {\n  margin-right: 16px !important;\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n.c-share-item {\n  height: 56px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
